<template>
	<script type="text/x-template" id="template-lut">
		<li class="block look_block lut-block adjustment-block preview-based disabled">
		    <div class="header-container edit_block_header drag_handle">
		        <label class="lookup_block_name name">Look block</label>
		    </div>

		    <div class="block_options">
		        <div class="lut-selector">
		            <div class="lut-selector__label-container">
		                <span class="selected-lut-name">Select...</span>
		                <i class="material-icons">expand_more</i>
		                <i class="btn-reset-selection material-icons" data-tippy-content="Remove selection">settings_backup_restore</i>
		            </div>
		            <div class="lut-selector__items-container"></div>
		        </div>
		    </div>
		</li>
	</script>
</template>

<script>
export default {};
</script>

<style></style>
